import React from "react";
import CreditVehicleTable from "../components/CreditVehicleTable/index.js";

const Home = props => <CreditVehicleTable {...props} />;

export default Home;
